import React from "react";
import WarpLogo from "../assets/images/Warspeed-Logo-Color.svg";

export default function Header() {
  return (
    <div className="md:absolute md:top-4 md:left-40 flex justify-center py-4 md:py-0 bg-white">
      <div className="md:relative">
        <img
          src={WarpLogo}
          alt="Warspeed Logo"
          className="warp-logo h-[75px]"
        />
      </div>
    </div>
  );
}
